// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"sliderWrapper-goqWNjkF"};